import { ReactNode } from "react";
import { useLocation } from "@tanstack/react-router";
import LeftSidebar from "./LeftSidebar";

interface DashboardLayoutProps {
  children?: ReactNode;
}

export default function DashboardLayout({ children }: DashboardLayoutProps) {
  const { pathname } = useLocation();

  // Extract projectId from project routes so sidebar can highlight it
  const projectMatch = pathname.match(/^\/dashboard\/projects\/([^/]+)/);
  const currentProjectId = projectMatch?.[1] || undefined;

  return (
    <div className="flex h-screen" style={{ backgroundColor: 'var(--surface)' }}>
      <LeftSidebar
        currentProjectId={currentProjectId}
      />
      <main className="flex-1 overflow-hidden pt-4 pr-4 pb-4 pl-4" style={{ backgroundColor: 'var(--surface)' }}>
        <div className="h-full rounded-lg overflow-auto" style={{ backgroundColor: 'var(--surface-alt)' }}>
          {children}
        </div>
      </main>
    </div>
  );
}
